var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrangeFooter"},[_c('span',{on:{"click":_vm.arrangeView}},[_vm._v("安排面试")]),_c('span',{on:{"click":_vm.zitoElimination}},[_vm._v("淘汰")])])}
var staticRenderFns = []

export { render, staticRenderFns }